import graphql__39fe3a26fc436cdd7143 from "./__generated__/PageSectionSidebarText_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import { useSidebarSectionTitle } from "./useSidebarSectionTitle";
import RichText from "../Utils/RichText";

const PageSectionSidebarText = props => {
  const pageSection = useFragment(PageSectionSidebarText_pageSection, props.pageSection);

  const { content } = pageSection;
  const { title } = useSidebarSectionTitle({ pageSection });

  return (
    <div className="page-section page-section-sidebar-text box page-section-sidebar-box">
      {title}

      <RichText
        className="page-section-sidebar-text-body padding-md border-radius-bottom"
        content={content}
      />
    </div>
  );
};

const PageSectionSidebarText_pageSection = graphql__39fe3a26fc436cdd7143;

export default PageSectionSidebarText;
